var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.2768,
    y: 1.0185,
    width: 36.8548,
    height: 36.8866,
    rx: 4.5274,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.2768,
    y: 1.0185,
    width: 36.8548,
    height: 36.8866,
    rx: 4.5274,
    stroke: "#DEDFEC",
    strokeWidth: 0.945207
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1718 22.8293L22.8287 17.1724M15.0509 19.2935L13.6366 20.7077C12.0745 22.2698 12.0741 24.8027 13.6362 26.3648C15.1983 27.9269 17.7317 27.9264 19.2938 26.3643L20.7065 24.9502M19.2929 15.0505L20.7071 13.6363C22.2692 12.0742 24.8016 12.0745 26.3637 13.6366C27.9258 15.1987 27.9257 17.7313 26.3636 19.2934L24.9501 20.7076",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/AttachmentIcon.3b0283e0204d3be35ff752e08f8e001f.svg";
export { ForwardRef as ReactComponent };